@if (navbarService.shouldShowNavBar()) {
  <mat-toolbar
    class="desktop-view container"
    [class.marketplace-header]="isMarketplacePage()"
  >
    <div>
      <a [routerLink]="['portal']">
        <img
          src="assets/vite-marketplace-logo-dark.svg"
          [alt]="translationService.getBrandLogoText()"
          class="brand-logo"
        />
      </a>
    </div>

    @if (!isMarketplacePage()) {
      <div class="product-search-bar">
        <app-product-search></app-product-search>
      </div>
    }
    @if (marketplace.canUseCart()) {
      <a
        mat-icon-button
        routerLink="/requisition-cart"
        class="cart-link desktop-cart-link"
        [attr.aria-label]="
          translationService.getRequisitionCartCountText(
            marketplace.cartCount()
          )
        "
      >
        <span
          class="cart-icon"
          [matBadge]="marketplace.cartCount()"
          aria-hidden="true"
        >
          <mat-icon>shopping_cart</mat-icon>
        </span>
      </a>
    }
    <div>
      <button
        mat-button
        class="location-btn"
        (click)="locationService.showLocationDialog(dialog)"
      >
        <mat-icon class="nav-icon">location_on</mat-icon>
        &nbsp; {{ userLocation }}
      </button>
    </div>
    <div>
      <button
        mat-button
        [matMenuTriggerFor]="menu"
        #menuTrigger="matMenuTrigger"
        (mouseenter)="menuTrigger.openMenu()"
        class="account-btn"
      >
        <mat-icon class="nav-icon">person</mat-icon>
        &nbsp; <span>{{ translationService.getAccountText() }}</span>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="goToSettings()">
          {{ translationService.getSettingsText() }}
        </button>
        @if (!authService.isLoggedIn()) {
          <button mat-menu-item (click)="login()">
            {{ translationService.getLoginText() }}
          </button>
        } @else {
          <button mat-menu-item (click)="logout()">
            {{ translationService.getLogoutText() }}
          </button>
        }
      </mat-menu>
    </div>
  </mat-toolbar>

  <mat-toolbar class="mobile-view">
    <ul class="navbar-list">
      <li class="nav-item">
        <a
          class="mobile-brand"
          [routerLink]="['']"
          [attr.aria-label]="translationService.getBrandHomeText()"
        >
          <img
            src="assets/vite-marketplace-logo-dark.svg"
            [alt]="translationService.getBrandLogoText()"
          />
        </a>
      </li>
      @if (marketplace.canUseCart()) {
        <li class="nav-item cart-nav-item">
          <a
            mat-icon-button
            routerLink="/requisition-cart"
            class="cart-link mobile-cart-link"
            [attr.aria-label]="
              translationService.getRequisitionCartCountText(
                marketplace.cartCount()
              )
            "
          >
            <span
              class="cart-icon"
              [matBadge]="marketplace.cartCount()"
              aria-hidden="true"
            >
              <mat-icon>shopping_cart</mat-icon>
            </span>
          </a>
        </li>
      }
      <li class="nav-item mobile-menu-li">
        <button
          mat-icon-button
          aria-label="Menu Icon"
          (click)="toggleSideMenuVisibility()"
        >
          <mat-icon aria-label="Side nav toggle icon" class="mobile-menu-icon">
            menu</mat-icon
          >
        </button>
      </li>
    </ul>
  </mat-toolbar>

  <app-side-menu
    [visible]="isSideMenuVisible"
    (toggleSideMenu)="toggleSideMenuVisibility()"
  ></app-side-menu>
}
